/**
 * Species skin details: cosmic
 */

export function drawSpecies_lithos(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Mạch cổ tự rune phát quang vàng cam rực chìm vi mô dưới da
  ctx.strokeStyle = '#f59e0b';
  ctx.lineWidth = 1.6;
  ctx.beginPath();
  ctx.moveTo(size * 0.35, size * 0.35);
  ctx.lineTo(size * 0.5, size * 0.55);
  ctx.lineTo(size * 0.65, size * 0.35);
  ctx.moveTo(size * 0.5, size * 0.55);
  ctx.lineTo(size * 0.5, size * 0.8);
  ctx.moveTo(size * 0.38, size * 0.68);
  ctx.lineTo(size * 0.62, size * 0.68);
  ctx.stroke();
}

export function drawSpecies_gem(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Giác cắt tinh thể lăng kính thạch anh phản quang
  ctx.strokeStyle = 'rgba(251, 146, 60, 0.75)';
  ctx.lineWidth = 1.4;
  ctx.strokeRect(size * 0.4, size * 0.42, 20, 20);
  ctx.beginPath();
  ctx.moveTo(size * 0.4, size * 0.42);
  ctx.lineTo(size * 0.4 + 20, size * 0.42 + 20);
  ctx.moveTo(size * 0.4 + 20, size * 0.42);
  ctx.lineTo(size * 0.4, size * 0.42 + 20);
  ctx.stroke();
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(size * 0.5 - 1.5, size * 0.52 - 1.5, 3, 3);
}

export function drawSpecies_mercury(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Giọt kim loại lỏng thủy ngân gợn sóng phản quang gương
  [
    [0.38, 0.42],
    [0.62, 0.46],
    [0.5, 0.65]
  ].forEach((pt) => {
    ctx.fillStyle = '#e2e8f0';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], 4.5, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(size * pt[0] - 1.2, size * pt[1] - 1.2, 1.8, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawSpecies_midas(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Hoa văn lá vàng hoàng kim phản quang rực rỡ
  ctx.strokeStyle = '#fef08a';
  ctx.lineWidth = 1.6;
  ctx.strokeRect(size * 0.4, size * 0.42, 20, 20);
  ctx.fillStyle = '#fde047';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.52, 4, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(size * 0.48, size * 0.5, 2, 2);
}

export function drawSpecies_steampunk(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Vệt rãnh bánh răng đồng và đinh tán cơ khí vi mô
  ctx.strokeStyle = '#854d0e';
  ctx.lineWidth = 1.5;
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.52, 12, 0, Math.PI * 2);
  ctx.stroke();
  for (let g = 0; g < 6; g++) {
    const a = (g * 60 * Math.PI) / 180;
    ctx.fillStyle = '#ca8a04';
    ctx.fillRect(size * 0.5 + Math.cos(a) * 12 - 1.5, size * 0.52 + Math.sin(a) * 12 - 1.5, 3, 3);
  }
}

export function drawSpecies_fulgor(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Nhánh tia chớp hồ quang xanh neon
  ctx.strokeStyle = '#38bdf8';
  ctx.lineWidth = 1.8;
  ctx.beginPath();
  ctx.moveTo(size * 0.55, size * 0.3);
  ctx.lineTo(size * 0.42, size * 0.5);
  ctx.lineTo(size * 0.58, size * 0.52);
  ctx.lineTo(size * 0.45, size * 0.75);
  ctx.stroke();
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(size * 0.42, size * 0.5, 2, 0, Math.PI * 2);
  ctx.fill();
}

export function drawSpecies_astral(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Bụi sao lấp lánh và đường nối chòm sao vi mô
  const starPts = [
    [0.35, 0.4],
    [0.62, 0.38],
    [0.5, 0.55],
    [0.38, 0.7],
    [0.65, 0.68]
  ];
  ctx.strokeStyle = 'rgba(199, 210, 254, 0.5)';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(size * starPts[0][0], size * starPts[0][1]);
  for (let s = 1; s < starPts.length; s++) {
    ctx.lineTo(size * starPts[s][0], size * starPts[s][1]);
  }
  ctx.stroke();
  starPts.forEach((pt) => {
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], 2, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawSpecies_zephyr(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Luồng gió lốc xoáy vi mô mềm mại
  ctx.strokeStyle = '#e0f2fe';
  ctx.lineWidth = 1.4;
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.52, 14, 0, Math.PI * 1.5);
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.52, 7, Math.PI * 0.5, Math.PI * 2);
  ctx.stroke();
}

export function drawSpecies_radiation(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Đốm hạt photon quang năng xanh cốm phát sáng vi mô
  [
    [0.38, 0.4],
    [0.62, 0.44],
    [0.5, 0.62],
    [0.35, 0.7]
  ].forEach((pt) => {
    ctx.fillStyle = '#bef264';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], 3.8, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(size * pt[0] - 1, size * pt[1] - 1, 1.4, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawSpecies_graviton(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Vòng đồng tâm trường trọng lực chìm vi mô
  ctx.strokeStyle = 'rgba(214, 211, 209, 0.6)';
  ctx.lineWidth = 1.2;
  [6, 13, 20].forEach((r) => {
    ctx.beginPath();
    ctx.arc(size * 0.5, size * 0.52, r, 0, Math.PI * 2);
    ctx.stroke();
  });
}

export function drawSpecies_chrono(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Bánh xe đồng hồ tròn và vạch số thời gian vi mô
  ctx.strokeStyle = '#fef08a';
  ctx.lineWidth = 1.4;
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.52, 16, 0, Math.PI * 2);
  ctx.stroke();
  for (let h = 0; h < 4; h++) {
    const a = (h * 90 * Math.PI) / 180;
    ctx.beginPath();
    ctx.moveTo(size * 0.5 + Math.cos(a) * 11, size * 0.52 + Math.sin(a) * 11);
    ctx.lineTo(size * 0.5 + Math.cos(a) * 16, size * 0.52 + Math.sin(a) * 16);
    ctx.stroke();
  }
}

export function drawSpecies_nebula(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Vầng mây plasma tinh vân tím hồng chuyển sắc và hạt bụi sao
  const nebGrad = ctx.createLinearGradient(size * 0.2, size * 0.3, size * 0.8, size * 0.7);
  nebGrad.addColorStop(0, 'rgba(232, 121, 249, 0.45)');
  nebGrad.addColorStop(1, 'rgba(168, 85, 247, 0.45)');
  ctx.fillStyle = nebGrad;
  ctx.beginPath();
  ctx.ellipse(size * 0.5, size * 0.52, size * 0.28, size * 0.15, Math.PI * 0.25, 0, Math.PI * 2);
  ctx.fill();
  [
    [0.4, 0.44],
    [0.58, 0.48],
    [0.48, 0.62],
    [0.65, 0.65]
  ].forEach((pt) => {
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], 1.8, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawSpecies_void(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Rãnh hư không hình thoi và đốm lượng tử chân không mờ ảo
  ctx.strokeStyle = 'rgba(147, 197, 253, 0.5)';
  ctx.lineWidth = 1.2;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.38);
  ctx.lineTo(size * 0.64, size * 0.52);
  ctx.lineTo(size * 0.5, size * 0.66);
  ctx.lineTo(size * 0.36, size * 0.52);
  ctx.closePath();
  ctx.stroke();
  [
    [0.42, 0.46],
    [0.58, 0.58]
  ].forEach((pt) => {
    ctx.fillStyle = '#93c5fd';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], 1.6, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawSpecies_singularity(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Vòng bồi tụ quang sai hố đen uốn cong ánh sáng
  ctx.strokeStyle = 'rgba(59, 130, 246, 0.7)';
  ctx.lineWidth = 1.5;
  ctx.beginPath();
  ctx.ellipse(size * 0.5, size * 0.52, 16, 7, Math.PI * -0.15, 0, Math.PI * 2);
  ctx.stroke();
  ctx.strokeStyle = 'rgba(250, 204, 21, 0.8)';
  ctx.lineWidth = 1.2;
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.52, 5, 0, Math.PI * 2);
  ctx.stroke();
  ctx.fillStyle = '#0f172a';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.52, 2.5, 0, Math.PI * 2);
  ctx.fill();
}

export const cosmic_species_drawers = {
  species_lithos: drawSpecies_lithos,
  species_gem: drawSpecies_gem,
  species_mercury: drawSpecies_mercury,
  species_midas: drawSpecies_midas,
  species_steampunk: drawSpecies_steampunk,
  species_fulgor: drawSpecies_fulgor,
  species_astral: drawSpecies_astral,
  species_zephyr: drawSpecies_zephyr,
  species_radiation: drawSpecies_radiation,
  species_graviton: drawSpecies_graviton,
  species_chrono: drawSpecies_chrono,
  species_nebula: drawSpecies_nebula,
  species_void: drawSpecies_void,
  species_singularity: drawSpecies_singularity
};
